(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (Controller, Config, Helper, Service, Handler, Model, Message, $, Password, CustomDimension, LocalStorage) {
  'use strict';

    Controller.inicioView = function (error, cb) {
        (error !== undefined) ? error = error.trim() : error = "";

        /* Antes que nada, si el modo es GLA y hay un error en la URL, muestro la vista de error. */
        if (Model.Window.modo === "GLA" && Model.Window.googleParams.errorGLA) {
            Service.mostrarError(Model.Window.googleParams.errorGLA);
            return;
        }


        Helper.callView('INICIO', {
            Error: error
        }, function () {

            if (Model.Window.modo !== 'CLA') {
                Service.getGmailInfo();
                Service.getFacebookInfo();
            }

            var username = $("#acceder_nativo_username");
            username.on('paste', function () {
                setTimeout(() => Helper.checkNextButton(username), 1);
            });
            username.focus();

            Helper.checkNextButton(username);

            switch (Model.Window.modo) {
                case 'D':
                    $('.top-content').addClass('default')
                    break;
                case 'S':
                    break;
                case 'P':
                    $('.top-content').addClass('default')
                    $('.top-content p').css('display', 'none');
                    break;
                case 'CLA':
                    $('.next-step').data('step', 'validar_tipo_asociacion_club');
                    break;
            }

            if (Helper.checkFirstStart() && Model.Window.modo !== 'CLA') {
                // Solo intenta obtener y logear con la credencial al cargar por primera vez.
                Service.autoLogin();
            }

            if (cb)
                cb();

        }, true, true);
    }

  Controller.accederNativo = function () {
    var username = $("#acceder_nativo_username");
    if (Helper.Validators.username.test(username.val()) || Helper.Validators.email.test(username.val())) {
      Helper.changeStatus(username, true);
      Model.Usuario.UsuarioUsuario = (Helper.Validators.username.test(username.val()) ? username.val() : (Helper.Validators.email.test(username.val()) ? username.val() : null));
      Model.Usuario.Email = (Helper.Validators.email.test(username.val()) ? username.val() : null);
      Service.ajaxPost('/Usuario/ExisteMailUsuario', Model.Usuario, function (res, status, xhr) {
        Handler.existeMailUsuarioResponseHandler(res, status, xhr);
        //Helper.hidePreloader();
      }, false, {
          showPreloader: true,
          //hidePreloader: true,
        });
    } else {
      Helper.changeStatus(username, false, Message.Usuario['USUARIO_INVALIDO'],  Message.Analytics.Usuario['USUARIO_INVALIDO']);
    }
  }

  Controller.accederNativoIngresarPasswordView = function () {
    Helper.callView('ACCEDER_NATIVO_INGRESAR_PASSWORD', null, function () {
      $("#acceder_nativo_password").focus().click();
      console.log('init-pass');
      if (Model.Usuario.NeedRecaptchaValidation) {
        Helper.Recaptcha.render('acceder_nativo_ingresar_password_recaptcha');
        $('#captcha-validation').show();
      }
      Helper.checkNextButton($('#acceder_nativo_password'));
      // Helper.checkCapsLock();
    });
  }

  Controller.accederRedSocialView = function () {
    Helper.callView('ACCEDER_RED_SOCIAL', null, function () {
      Service.getGmailInfo();
      Service.getFacebookInfo();
    });
  }

  Controller.accerNativoAutomatico = function (email, password) {
    Model.Usuario.Clave = password;
    Model.Usuario.UsuarioUsuario = email;
    Service.ajaxPost('/Usuario/Login', Model.Usuario, function (res, status, xhr) {
      var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(res.response, [1]);
      var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(res.response, [2]);

      if ((res.code == "0000") && (token == null || xvalue == null || !token || !xvalue)) {
        logger && logger.error('Login Nativo (Smartlock) | sin headers', { token, xvalue });
      }
      Handler.loginResponseHandler(res, status, xhr, true);
    }, false, {
        showPreloader: true
      });
  }


    Controller.accederNativoIngresarPassword = function (message) {
        var password = $("#acceder_nativo_password");

        if (!Model.Usuario.NeedRecaptchaValidation || Helper.Recaptcha.isSubmitted()) {
            Model.Usuario.Clave = password.val();
            Model.Usuario.Recaptcha = Model.Usuario.NeedRecaptchaValidation ? Helper.Recaptcha.getResponse() : '';

            Helper.changeStatus(password, true);
            Helper.cleanCustomMessageError($('#recaptcha-mensaje'));

            Service.ajaxPost('/Usuario/Login', Model.Usuario, function (res, status, xhr) {
                var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(res.response, [1]);
                var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(res.response, [2]);

                if ((res.code == "0000") && (token == null || xvalue == null || !token || !xvalue)) {
                    logger && logger.error('Login Nativo | sin headers ', { token, xvalue });
                }

                Handler.loginResponseHandler(res, status, xhr);
            }, false, {
                showPreloader: true
            });
        }
        else {
            Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_REQUERIDO'], Message.Analytics.Usuario['CAPTCHA_REQUERIDO']);
        }
    }








  Controller.finalizarAcceder = function () {
    Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
      if (!Helper.isEmpty(res.response)) {
        var usuario = JSON.parse(res.response);
        Model.Usuario.ClubNacion = (usuario.Usuario.ClubNacion === undefined) ? "" : usuario.Usuario.ClubNacion;
        Model.Usuario.Avatar = usuario.Usuario.Usuario_detalle_foto_perfil;
        Model.Usuario.Email = usuario.Usuario.usuarioemail;
        Model.Usuario.UsuarioDetalleApellido = usuario.Usuario.UsuarioDetalleApellido;
        Model.Usuario.UsuarioDetalleNombre = usuario.Usuario.UsuarioDetalleNombre;

        Helper.setupCookies(usuario.Usuario);

        /* Si es modo GLA, acá tengo que modificar el window.pagina para corregir la url de callback */
        if (Model.Window.modo === "GLA") {
          Model.Window.pagina = `${Model.Window.googleParams.redirect_uri}#access_token=${usuario.Usuario.TokenJWT}&token_type=bearer&state=${Model.Window.googleParams.state}`
          console.log(Model.Window.pagina);
        }

        CustomDimension.setUserId(usuario.Usuario.UsuarioId);
        CustomDimension.save();

        //Lanzo evento en localstorage
        LocalStorage.setItem('userLogedIn', true);
        localStorage.removeItem('userLogedIn');

        // Busco el producto y lo asigno al CustomDimension
        Service.ajaxPost('/1/SuscripcionV1/ObtenerSuscripcionDigitalAnalytics', {}, function (res, status, xhr) {
          if (res.code && res.code == '0000') {
            CustomDimension.setSuscriptorType(res.response.nombre);
          } else {
            CustomDimension.setSuscriptorType('N/A');
          }
          CustomDimension.setRegistrado('yes');
          CustomDimension.save();

          Service.createCustomDimension();
        }, null, {
            paywallApi: true,
            sentHeader: true
          });

        Handler.finalizarAccederHandler();
      }
    }, null, {
        sentHeader: true
      });
  }

  /* LM */
  // Se ejecuta luego de asociar credencial en caso black, para validad que la credencial que se asoci� corresponde a Black, u a otro tipo . 
  Controller.validarCredencialBlack = function () {
    Helper.updateToken();
    Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
      if (!Helper.isEmpty(res.response)) {
        var usuario = JSON.parse(res.response);
        Model.Usuario.ClubNacion = (usuario.Usuario.ClubNacion === undefined) ? "" : usuario.Usuario.ClubNacion;  // Actualizo tipo de credencial que tiene le usuario asociada . 
        Handler.validarCredencialBlackHandler();
      }
    }, null, {
        sentHeader: true
      });
  }

  Controller.reestablecerPassword = function () {

    // Si viene desde inicio (primera pantalla de login), valido el mail y se envia a reestablecer password precargardo.
    var email = Model.Usuario.Email || "";
    var usuario = Model.Usuario.UsuarioUsuario || "";
    if (email == "" && usuario == "") {
      var username = $("#acceder_nativo_username");
      if (Helper.Validators.username.test(username.val()) || Helper.Validators.email.test(username.val())) {
        Helper.changeStatus(username, true);
        Model.Usuario.UsuarioUsuario = (Helper.Validators.username.test(username.val()) ? username.val() : (Helper.Validators.email.test(username.val()) ? username.val() : null));
        Model.Usuario.Email = (Helper.Validators.email.test(username.val()) ? username.val() : null)
      }
    }

    Helper.callView('REESTABLECER_PASSWORD', null, function () {
      Helper.Recaptcha.render('restablecer_password_recaptcha');
      // Autocompleto campo mail si lo tengo ingresado desde antes . 
      var email = $("#reestablecer_password_email");
      email.val(Model.Usuario.Email).focus();
      // Muestro activo el bot�n "Confirmar" si el mail ingresado es correcto . 
      if (Model.Usuario.Email != null && Model.Usuario.Email != "") {
        (Helper.Validators.email.test(Model.Usuario.Email)) ? $("button.login").addClass("active") : Helper.changeStatus(email, false, 'Ingresá un e-mail válido', 'Ingresá un e-mail válido');
      }


    });
  }
  /* LM */

  Controller.reestablecerPasswordProcesar = function () {
    var email = $("#reestablecer_password_email");
    Helper.cleanCustomMessageError($('#recaptcha-mensaje'));
    if (Helper.Validators.email.test(email.val()) && Helper.Recaptcha.isSubmitted()) {
      Helper.changeStatus(email, true);
      Model.Usuario.Email = email.val();
      Model.Usuario.Recaptcha = Helper.Recaptcha.getResponse();
      Model.Usuario.Retorno = window.location.href;

      Service.ajaxPost('/Usuario/ExisteMailUsuario', Model.Usuario, function (res) {
        if (res.code != '0000') {
          Helper.changeStatus(email, false, 'Ingresá un e-mail válido', 'Ingresá un e-mail válido');
          Helper.Recaptcha.reset();
        } else {
          Service.ajaxPost('/Usuario/ValidarUsuarioOlvidoClaveMailRecaptcha', Model.Usuario, function (res, status, xhr) {
            Handler.olvidoClaveHandler(res, status, xhr);
            Helper.Recaptcha.reset();
          }, null, {
              showPreloader: true,
              hidePreloader: true
            });
        }
      });

    } else {
      if (Helper.Validators.email.test(email.val())) Helper.changeStatus(email, true);
      else Helper.changeStatus(email, false, 'Ingresá un e-mail válido', 'Ingresá un e-mail válido');

      if (recaptcha.val() == '') {        
        Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_REQUERIDO'], Message.Analytics.Usuario['CAPTCHA_REQUERIDO']);
      }
      else Helper.Recaptcha.reset();
    }
  }

  Controller.reestablecerPasswordCodigoLoad = function () {
    Service.ajaxPost('/Usuario/ValidarCambioContrasenia', Model.Usuario, function (res, status, xhr) {
      Handler.olvidoClaveCodigoLoadHandler(res, status, xhr);
    }, null, {
        showPreloader: true,
        hidePreloader: true
      });
  }


  Controller.reestablecerPasswordEnvioView = function (message) {
    Helper.callView('REESTABLECER_PASSWORD_ENVIO', {
      Message: message
    }, function () {
    }, true);
  }

  Controller.reestablecerPasswordCodigoView = function (message) {
    Helper.callView('REESTABLECER_PASSWORD_CODIGO', {
      Message: message
    }, function () {
      $(".val-nueva-clave").strongpass(); // LM : Agrego en callback el listener para el keyup de clave nueva . 
      Helper.disableNextButton();
    }, true);
  }

  Controller.reestablecerPasswordExpiradoView = function (message) {
    Helper.callView('REESTABLECER_PASSWORD_EXPIRADO', {
      Message: message
    }, function () {
      Helper.Recaptcha.render('restablecer_password_recaptcha');
      $("#reestablecer_password_codigo_password").focus();
      $(".val-nueva-clave").strongpass(); // LM : Agrego en callback el listener para el keyup de clave nueva . 
    }, true);
  }

  Controller.reestablecerPasswordCodigo = function () {
    var password = $("#reestablecer_password_codigo_password");
    var repetirPassword = $("#reestablecer_password_codigo_repetir_password");
    if (Password.canSubmit(true) && Helper.Validators.passwordRegistro.test(password.val()) && Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
      if (password.val() === repetirPassword.val()) {
        Helper.changeStatus(password, Helper.Validators.password.test(password.val()));
        Helper.changeStatus(repetirPassword, Helper.Validators.password.test(repetirPassword.val()));
        Model.Usuario.Clave = password.val();
        Service.ajaxPost('/Usuario/ActualizarClaveUsuario', Model.Usuario, function (res, status, xhr) {
          Handler.olvidoClaveCodigoHandler(res, status, xhr);
        }, null, {
            showPreloader: true
          });
      }
    }
    else {
      //if (!Helper.Validators.passwordRegistro.test(password.val())) {
      //    Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG']);
      //}

      //if (!Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
      //    Helper.changeStatus(repetirPassword, Helper.Validators.passwordRegistro.test(repetirPassword.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG']);
      //}
    }
  }

  Controller.reestablecerPasswordExpiradoCodigo = function () {
    var password = $("#reestablecer_password_codigo_password");
    var repetirPassword = $("#reestablecer_password_codigo_repetir_password");

    if (Password.canSubmit(true) && Helper.Validators.passwordRegistro.test(password.val()) && Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
      if (password.val() === repetirPassword.val()) {
        Helper.changeStatus(password, Helper.Validators.password.test(password.val()));
        Helper.changeStatus(repetirPassword, Helper.Validators.password.test(repetirPassword.val()));
        var data = {
          ClaveVieja: Model.Usuario.Clave,
          ClaveNueva: password.val(),
          Recaptcha: Helper.Recaptcha.getResponse()
        };
        Model.Usuario.xKey = Math.random(); // Este parámetro solo va para requests de token temporal 
        Service.ajaxPost('/Usuario/ActualizarClave', data, function (res, status, xhr) {
          Handler.olvidoClaveCodigoHandler(res, status, xhr);
          Model.Usuario.xKey = "";
        }, null, {
            showPreloader: true,
            sentHeader: true
          });
      }
    }
    else {
      if (!Helper.Validators.passwordRegistro.test(password.val())) {
        Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG'], Message.Analytics.Usuario['CARACTER_INVALIDO_PASS_REG']);
      }

      if (!Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
        Helper.changeStatus(repetirPassword, Helper.Validators.passwordRegistro.test(repetirPassword.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG'], Message.Analytics.Usuario['CARACTER_INVALIDO_PASS_REG']);
      }
    }
  }


  Controller.reestablecerPasswordCodigoGraciasView = function () {
    Helper.callView('REESTABLECER_PASSWORD_CODIGO_GRACIAS');
  }

  /* HANDLER CALLBACKS */
  Controller.accederNativoIngresarPasswordErrorCallBack = function (message) {
    $('#acceder_nativo_ingresar_password .mostrar').addClass('error');
    $('#mostrar_error_mensaje').html(message);
  }

  Controller.reestablecerPasswordSuccessCallBack = function () {
    $('.sinCaptcha').show();
    $(".confirmar-hidden").hide(); // LM
  }

  Controller.retornarAcceder = function () {
    (!Helper.isEmpty(Model.Window.pagina)) ? Helper.redirectUrl(Model.Window.pagina) : Helper.redirectUrl(Config.defaultUrl);
  }

  Controller.logout = function (options) {
    Helper.resetAll(function () {
      Model.Usuario.xToken = Helper.readCookie("token");
      Model.Usuario.xValue = Helper.readCookie("xvalue");
      Service.ajaxPost('/Usuario/Logout', Model.Usuario, function (res, status, xhr) {
        Handler.logoutHandler(res, status, xhr, options);
        Service.smartlockSignOut();
      }, function () {
        Helper.returnBackLogout(options);
      }, {
          sentHeader: true
        });
    })
  }

  Controller.logoutV2 = function (options) {
    var reset = function () {
      Helper.resetAll(function () {
      });
    };
    try {
      Model.Usuario.xToken = Helper.readCookie("token");
      Model.Usuario.xValue = Helper.readCookie("xvalue");
      if ((Model.Usuario.xToken != null) && (Model.Usuario.xValue != null) && Model.Usuario.xToken && Model.Usuario.xValue) {
        Service.ajaxPost('/Usuario/Logout', Model.Usuario, function (res, status, xhr) {
          reset();
          Service.smartlockSignOut();
          Handler.logoutHandler(res, status, xhr, options);
        }, function () {
          reset();
          Helper.returnBackLogout(options);
        }, {
            sentHeader: true
          });
      } else {
        reset();
      }
    }
    catch (ex) {
      reset();
    }

  }

    Controller.facilitarAccesoGoogle = function () {
        Helper.callView('FACILITAR_ACCESO_GOOGLE', null, function () {
            Service.getGmailInfo();
        });
    }

})(LN.Controller, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, jQuery, Password.Validator, LN.CustomDimension, LN.LocalStorage);


// WEBPACK FOOTER //
// ./Statics/scripts/login/controllers/nativo.js